/**
 * SFrame254 — Receipt log & correspondence between beneficiaries and executor.
 */

import { useParams, Link } from 'react-router-dom';
import ClosePhaseChrome from './ClosePhaseChrome';

export default function SFrame254() {
  const { estateId } = useParams<{ estateId: string }>();
  const suffix = estateId ? `/${estateId}` : '';

  return (
    <ClosePhaseChrome
      estateId={estateId}
      title="Receipt & correspondence log"
      subtitle="Maintain a simple narrative of who received what and when. Formal signatures are tracked on the previous screen; this page is for your internal notes."
    >
      <div className="rounded-lg border border-slate-200 bg-slate-50 p-4 text-sm text-slate-700 max-w-3xl">
        <p>
          Keep copies of emails or letters confirming each beneficiary understands the final accounting. If your court
          requires a specific affidavit format, attach those PDFs when uploading documents on the discharge step.
        </p>
      </div>
      <div className="flex flex-wrap gap-4 text-sm print:hidden">
        <Link to={`/sframe-253${suffix}`} className="text-blue-800 hover:underline">
          ← Beneficiary approvals
        </Link>
        <Link to={`/sframe-255${suffix}`} className="font-medium text-blue-800 hover:underline">
          Court discharge →
        </Link>
      </div>
    </ClosePhaseChrome>
  );
}
